import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AccountAuthorization } from 'src/model/accountAuthorization';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { AccountAuthorizationService } from 'src/services/accountAuthorization.service';
import { ProcessAuthorizationComponent } from '../process-authorization/process-authorization.component';

@Component({
    selector: 'app-accountAuthorizationHistory',
    templateUrl: './accountAuthorizationHistory.component.html',
    styleUrls: ['./accountAuthorizationHistory.component.scss'],
    standalone: false
})
export class AccountAuthorizationHistoryComponent implements OnInit {
  private accountAuthorizationService = inject(AccountAuthorizationService);
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);

  @Input() accountDetails: CustomerAccount;

  authorizationList: AccountAuthorization[] = [];

  async ngOnInit() {

    this.authorizationList = await this.accountAuthorizationService.getAccountAuthorizations(this.accountDetails.Id);
    this.authorizationList.sort((a, b) => (a.ID < b.ID) ? 1 : -1);

  }

  confirmBeforeAction(auth: AccountAuthorization) {
    const modalRef = this.sharedService.openModal(ProcessAuthorizationComponent);
    modalRef.componentInstance.authorization = auth;
    modalRef.componentInstance.accountDetails = this.accountDetails;

  }

  reset() {
    this.activeModal.close();
  }

}
